import { useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import PandaVideos from "../../../../../../features/misc/components/PandaVideos.";
import FileInput from "../FileInput";
import { Close } from "@mui/icons-material";

function VideoInput({ onChange, videoUrl }) {
  const [isListOpen, setIsListOpen] = useState(false);
  const close = () => {
    setIsListOpen(false);
  };
  return (
    <Box sx={{ width: "100%", marginX: "auto" }}>
      <FileInput
        title="Escolha como incluir o video:"
        onClickUpload={() => setIsListOpen(true)}
        url={videoUrl}
        onSetUrl={(value) => {
          onChange(value.replace("shorts", "embed"));
        }}
        uploadLabel="Selecionar"
      />

      <Dialog
        open={isListOpen}
        onClose={close}
        maxWidth={"lg"}
        fullWidth={true}
      >
        <DialogTitle>Vídeos</DialogTitle>
        <IconButton
          onClick={close}
          sx={{ position: "absolute", top: 3, right: 3 }}
        >
          <Close />
        </IconButton>
        <DialogContent>
          <PandaVideos
            onSelectVideo={(videoUrl) => {
              setIsListOpen(false);
              onChange(videoUrl);
            }}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default VideoInput;
